export default __webpack_public_path__ + "static/media/ovo_l.4d592fe5.jpg";